import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ivclass from '../../Modules/IVClass';
const FooterLink = (props) => {
    const { url, external = false, children, onClick } = props;
    const linkProps = {
        onClick: null,
        href: url,
    };
    if (onClick) {
        linkProps.onClick = onClick;
    }
    else {
        linkProps.href = url;
    }
    const classes = [
        'xl:iv-pb-5 iv-pb-7 xl:iv-pt-4',
        'iv-text-grey-60 dark:iv-text-white-30',
        'xl:iv-text-body-l iv-text-body-m',
    ];
    return (_jsx(React.Fragment, { children: (onClick && (_jsx("span", { className: ivclass([...classes], 'iv-cursor-pointer'), ...linkProps, children: children }))) || (_jsx("a", { target: external ? '_blank' : '', rel: "noreferrer", className: ivclass([...classes]), ...linkProps, children: children })) }));
};
export default FooterLink;
